module.exports = __webpack_public_path__ + "static/media/ic_email_regular.819b05a1.svg";